import { useQuery } from '@tanstack/react-query';

import useAuth from '@/hooks/useAuth';
import getCurrentUserId from '@/utils/user/getCurrentUserId';
import { isGenaiWebHost, isPortfolioApp } from '@/utils/environment/surface';

import resolveOnboardingState from '../resolveOnboardingState';

const ONBOARDING_STATE_KEY_ROOT = ['onboarding-state'];

/** Reads and writes share this so the two can never drift out of scope. */
export const getOnboardingStateKey = () => [
  ...ONBOARDING_STATE_KEY_ROOT,
  getCurrentUserId(),
];

const useOnboardingState = () => {
  const { isAuthorized } = useAuth();

  return useQuery({
    queryKey: getOnboardingStateKey(),
    queryFn: resolveOnboardingState,
    enabled: isAuthorized && isPortfolioApp() && !isGenaiWebHost(),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });
};

export default useOnboardingState;
